import React from "react";

export default function App() {
  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#1a1a1a",
        color: "#f5f5f5",
        fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
        textAlign: "center",
        padding: "2rem",
      }}
    >
      <h1
        style={{
          fontSize: "clamp(1.75rem, 5vw, 3rem)",
          fontWeight: 600,
          letterSpacing: "0.02em",
          margin: 0,
        }}
      >
        Site Undergoing Maintenance
      </h1>
      <p
        style={{
          marginTop: "1rem",
          fontSize: "1rem",
          opacity: 0.75,
          maxWidth: "32rem",
        }}
      >
        We'll be back shortly. Thank you for your patience.
      </p>
    </div>
  );
}

// import React from 'react';
// import { Routes, Route, Link } from 'react-router-dom';
// import Header from './components/Header';
// import Footer from './components/Footer';
// import Home from './components/Home';
// import Page from './components/Page';

// export default function App() {
//   return (
//     <div className="min-h-full flex flex-col">
//       <Header />
//       <main role="main" aria-label="Main content" className="w-full max-w-bh mx-auto px-4 pb-8 text-center grow">
//         <Routes>
//           <Route path="/" element={<Home />} />

//           <Route
//             path="/about"
//             element={
//               <Page title="About GLEN UNION CAPITAL INC.">
//                 <div className="text-left space-y-4">
//                   <p>
//                     <strong>GLEN UNION CAPITAL INC.</strong> is an Ontario Business Corporation
//                     based in Richmond Hill, Ontario (est. 2015). We own and operate <strong>Karvon Investments Ltd.</strong>
//                     Through Karvon, we <strong>facilitate investments in lithium, data-centre, and AI infrastructure</strong>
//                     in Canada and selected global markets.
//                   </p>

//                   <div>
//                     <p className="font-semibold">Company identifiers</p>
//                     <ul className="list-disc pl-6">
//                       <li>GLEN UNION CAPITAL INC. - Business Number (BN): 821677325; Registry ID: 2468638; Status: Active</li>
//                       <li>Karvon Investments Ltd. - Business Number (BN): 899970363; Registry ID: 861656</li>
//                     </ul>
//                   </div>

//                   <div>
//                     <p className="font-semibold">Registration (Ontario)</p>
//                     <p>
//                       GLEN UNION CAPITAL INC. is <strong>registered with the Ontario Securities Commission (OSC)</strong>.
//                        <a href="https://www.osc.ca/en/industry/registration-and-compliance/registrant-search" target="_blank" rel="noreferrer">Registrant Search</a>.
//                       Our <strong>NRD number is 52370</strong> and our registration categories are:
//                     </p>
//                     <ul className="list-disc pl-6">
//                       <li><strong>Investment Fund Manager</strong></li>
//                       <li><strong>Portfolio Manager</strong></li>
//                     </ul>
//                     <p className="mt-2">
//                       Helpful links:&nbsp;
//                       <a href="https://www.osc.ca" target="_blank" rel="noreferrer">Ontario Securities Commission (OSC)</a> &middot;{' '}
//                       <a href="https://www.osc.ca/en/industry/registration-and-compliance/registrant-search/registered-firms-list" target="_blank" rel="noreferrer">Registered Firms List</a> &middot;{' '}
//                       <a href="https://www.osc.ca/sites/default/files/2023-03/reg_registrants_20230302.pdf" target="_blank" rel="noreferrer">List of Ontario Registrants (PDF)</a>
//                     </p>
//                   </div>

//                   <div>
//                     <p className="font-semibold">What those categories mean (briefly)</p>
//                     <p>
//                       Under <em>National Instrument 31-103 – Registration Requirements, Exemptions and Ongoing Registrant Obligations</em> and its
//                       <em> Companion Policy (31-103CP)</em>, an <strong>Investment Fund Manager</strong> directs the business, operations, or affairs of an investment fund,
//                       and a <strong>Portfolio Manager</strong> provides discretionary portfolio management/advice. These frameworks also embed core obligations
//                       (e.g., KYC/KYP, suitability, conflicts management, CRM2 reporting, and ongoing compliance oversight).
//                     </p>
//                     <p>
//                       References:&nbsp;
//                       <a href="https://www.osc.ca/en/securities-law/instruments-rules-policies/3/31-103" target="_blank" rel="noreferrer">NI 31-103 (OSC)</a> &middot;{' '}
//                       <a href="https://www.osc.ca/en/securities-law/instruments-rules-policies/3/31-103/unofficial-consolidation-companion-policy-31-103cp-registration-requirements-exemptions-and-1" target="_blank" rel="noreferrer">31-103CP (Companion Policy)</a>
//                     </p>
//                   </div>

//                   <div>
//                     <p className="font-semibold">National Registration Database (NRD)</p>
//                     <p>
//                       Firm registrations are administered through Canada’s <strong>National Registration Database (NRD)</strong>,
//                       maintained by the Canadian Securities Administrators (CSA). Learn more:&nbsp;
//                       <a href="https://www.securities-administrators.ca/national-systems/nrd/" target="_blank" rel="noreferrer">About NRD (CSA)</a>.
//                     </p>
//                   </div>

//                   <div>
//                     <p className="font-semibold">How we operate (concise)</p>
//                     <ul className="list-disc pl-6">
//                       <li>Long-horizon capital allocation in real-asset and infrastructure adjacencies (lithium, data-centre, AI infrastructure).</li>
//                       <li>Discretionary portfolio management under Ontario securities law.</li>
//                       <li>Institutional-grade compliance program covering governance, risk, valuation, cybersecurity, business continuity, and client reporting aligned with NI 31-103/31-103CP.</li>
//                     </ul>
//                   </div>

//                 </div>
//               </Page>
//             }
//           />

//           <Route
//             path="/owner-manual"
//             element={
//               <Page title="Owner’s Manual">
//                <Page title="Owner’s Manual">
//   <div className="text-left space-y-4">
//     <p>
//       This Owner’s Manual summarizes how we invest, manage risk, communicate, and align incentives at
//       <strong> GLEN UNION CAPITAL INC.</strong> We keep it short, practical, and specific enough to be useful.
//     </p>

//     <div>
//       <p className="font-semibold">Our principles</p>
//       <ul className="list-disc pl-6 space-y-1">
//         <li><strong>Alignment:</strong> We invest alongside stakeholders and keep fee structures simple and disclosed.</li>
//         <li><strong>Circle of competence:</strong> We focus on domains we know-through <a href="/subsidiaries" className="underline">Karvon</a>, this includes lithium, data-centre, and AI-infrastructure adjacencies.</li>
//         <li><strong>Risk first:</strong> We prioritize capital preservation, liquidity under stress, and prudent concentration.</li>
//         <li><strong>Long horizon:</strong> Patient compounding beats activity. We act decisively only when risk-reward is attractive.</li>
//         <li><strong>Cost &amp; tax awareness:</strong> We minimize frictional costs and are mindful of after-fee, after-tax results.</li>
//         <li><strong>Capacity discipline:</strong> We cap strategies to protect returns and client experience.</li>
//         <li><strong>Integrity &amp; compliance:</strong> We operate under Canadian securities law (NI 31-103/31-103CP) and our internal policies.</li>
//       </ul>
//     </div>

//     <div>
//       <p className="font-semibold">Capital allocation playbook</p>
//       <ul className="list-disc pl-6 space-y-1">
//         <li><strong>Underwrite downside first:</strong> What can go wrong? What is the permanent loss risk?</li>
//         <li><strong>Structural edges:</strong> Prefer durable advantages (access, data, technical expertise, or time horizon).</li>
//         <li><strong>Unit economics &amp; cash:</strong> We value real cash generation and returns on incremental capital.</li>
//         <li><strong>Price vs. value:</strong> We require a margin of safety; we avoid leverage where it manufactures risk.</li>
//         <li><strong>Concentration with intent:</strong> Concentrate only where we have conviction and risk controls.</li>
//         <li><strong>Exit discipline:</strong> Pre-define conditions to scale, hold, or exit; avoid narrative drift.</li>
//       </ul>
//     </div>

//     <div>
//       <p className="font-semibold">Risk management &amp; controls</p>
//       <ul className="list-disc pl-6 space-y-1">
//         <li><strong>Governance:</strong> Clear roles, documented policies, independent oversight where appropriate.</li>
//         <li><strong>Suitability &amp; KYC/KYP:</strong> Decisions reflect client objectives, constraints, and risk tolerance.</li>
//         <li><strong>Liquidity:</strong> Position sizing considers stressed liquidity and funding needs.</li>
//         <li><strong>Counterparty &amp; custody:</strong> We use independent custodians/brokers; counterparties are reviewed periodically.</li>
//         <li><strong>Valuation:</strong> Consistent methods and oversight; issues are escalated promptly.</li>
//         <li><strong>Operational resilience:</strong> Cybersecurity and business continuity plans are maintained and tested.</li>
//         <li><strong>Conflicts:</strong> Identified, avoided where possible, otherwise disclosed and controlled.</li>
//       </ul>
//     </div>

//     <div>
//       <p className="font-semibold">Communication &amp; reporting</p>
//       <ul className="list-disc pl-6 space-y-1">
//         <li><strong>Plain language:</strong> We communicate clearly, infrequently, and only when useful.</li>
//         <li><strong>Periodic updates:</strong> Annual updates and occasional letters; news posted on our site as needed.</li>
//         <li><strong>Client reporting:</strong> Statements via custodians and applicable performance/fee disclosures (CRM2) as required.</li>
//         <li><strong>Errors &amp; corrections:</strong> We own mistakes and correct them promptly.</li>
//       </ul>
//     </div>

//     <div>
//       <p className="font-semibold">How to work with us</p>
//       <ol className="list-decimal pl-6 space-y-1">
//         <li><strong>Introductory inquiry:</strong> Reach us via <a href="/contact" className="underline">Contact</a> or explore <a href="/subsidiaries" className="underline">Subsidiaries &amp; Investments</a>.</li>
//         <li><strong>Discovery &amp; onboarding:</strong> KYC/KYP, suitability, and account opening with our custodial partners.</li>
//         <li><strong>Implementation:</strong> Portfolio construction and funding according to your objectives and constraints.</li>
//         <li><strong>Ongoing review:</strong> Periodic check-ins, risk monitoring, and reporting.</li>
//       </ol>
//       <p className="text-sm">
//         Eligibility and offering terms vary and will be provided in the relevant agreements and disclosure documents
//         in accordance with applicable Canadian securities laws.
//       </p>
//     </div>

//     <div>
//       <p className="font-semibold">Karvon Investments Ltd.</p>
//       <p>
//         GLEN UNION CAPITAL INC. owns and operates <a href="https://karvon.co" target="_blank" rel="noreferrer" className="underline">Karvon Investments Ltd.</a>,
//         which facilitates investments in lithium, data-centre, and AI-infrastructure opportunities.
//       </p>
//     </div>

//     <div>
//       <p className="font-semibold">Verify our registration</p>
//       <p>
//         GLEN UNION CAPITAL INC.  NRD 52370 - categories: Investment Fund Manager; Portfolio Manager.&nbsp;
//         Verify via the OSC&nbsp;
//         <a href="https://www.osc.ca/en/industry/registration-and-compliance/registrant-search" target="_blank" rel="noreferrer" className="underline">
//           Registrant Search
//         </a>.
//       </p>
//     </div>

//     <p className="italic text-sm">
//       Informational only; not an offer or solicitation of securities. Any investment will be made only in compliance with
//       applicable Canadian securities laws and the relevant offering and account documents.
//     </p>
//   </div>
// </Page>

//               </Page>
//             }
//           />

//           <Route
//             path="/letters"
//             element={
//               <Page title="Annual Letters">
//                 <ul className="list-disc pl-6 text-left">
//                   <li><a href="%PUBLIC_URL%/docs/chairman-letter.pdf" target="_blank" rel="noreferrer">Chairman’s Letter (PDF)</a></li>
//                   <li><em>More letters can be added here as they’re published.</em></li>
//                 </ul>
//               </Page>
//             }
//           />

//           {/* <Route
//             path="/governance"
//             element={
//               <Page title="Corporate Governance">
//                 <ul className="list-disc pl-6 text-left">
//                   <li>Board &amp; Committees</li>
//                   <li>Code of Business Conduct</li>
//                   <li>Whistleblower Policy</li>
//                 </ul>
//               </Page>
//             }
//           /> */}

// <Route
//   path="/governance"
//   element={
//     <Page title="Corporate Governance">
//       <div className="text-left space-y-3">
//         <p>We maintain a clear governance framework and a compliance program aligned with Canadian securities law (NI 31-103 / 31-103CP).</p>
//         <ul className="list-disc pl-6">
//           <li><Link to="/policies/code-of-ethics" className="underline">Code of Ethics &amp; Conduct</Link></li>
//           <li><Link to="/policies/compliance-manual" className="underline">Compliance Manual (Overview)</Link></li>
//           <li><Link to="/policies/conflicts" className="underline">Conflicts of Interest</Link></li>
//           <li><Link to="/policies/personal-trading" className="underline">Personal Trading &amp; Restricted List</Link></li>
//           <li><Link to="/policies/best-execution" className="underline">Best Execution &amp; Trade Allocation</Link></li>
//           <li><Link to="/policies/valuation" className="underline">Valuation &amp; Pricing</Link></li>
//           <li><Link to="/policies/cybersecurity" className="underline">Cybersecurity</Link></li>
//           <li><Link to="/policies/business-continuity" className="underline">Business Continuity &amp; Disaster Recovery</Link></li>
//           <li><Link to="/policies/whistleblower" className="underline">Whistleblower</Link></li>
//           <li><Link to="/privacy" className="underline">Privacy (PIPEDA)</Link></li>
//           <li><Link to="/accessibility" className="underline">Accessibility (AODA)</Link></li>
//           <li><Link to="/complaints" className="underline">Complaint Handling</Link></li>
//         </ul>
//       </div>
//     </Page>
//   }
// />

//           {/* Code of Ethics & Conduct */}
// <Route
//   path="/policies/code-of-ethics"
//   element={
//     <Page title="Code of Ethics &amp; Conduct">
//       <div className="text-left space-y-3">
//         <p>Our reputation is built on integrity. This Code applies to all directors, officers, employees, and contractors.</p>
//         <ul className="list-disc pl-6">
//           <li>Act honestly, fairly, and in good faith; comply with applicable laws and policies.</li>
//           <li>Place client interests ahead of firm interests; avoid and disclose conflicts.</li>
//           <li>Protect confidential information; no misuse of material non-public information.</li>
//           <li>Personal conduct: no harassment or discrimination; maintain a professional environment.</li>
//           <li>Report concerns through our whistleblower channels without fear of retaliation.</li>
//         </ul>
//       </div>
//     </Page>
//   }
// />

// {/* Compliance Manual (Overview) */}
// <Route
//   path="/policies/compliance-manual"
//   element={
//     <Page title="Compliance Manual (Overview)">
//       <div className="text-left space-y-3">
//         <p>We operate under Canadian securities law, including NI 31-103 and 31-103CP. This overview summarizes our program.</p>
//         <ul className="list-disc pl-6">
//           <li>KYC/KYP &amp; Suitability: policies, documentation standards, and reviews.</li>
//           <li>Registration categories: Investment Fund Manager; Portfolio Manager.</li>
//           <li>Conflicts, personal trading, and gifts/entertainment controls.</li>
//           <li>Recordkeeping, books &amp; records, and privacy safeguards.</li>
//           <li>Monitoring, testing, training, and incident escalation.</li>
//         </ul>
//         <p className="text-sm italic">For clients, additional details are provided in onboarding and relationship disclosure documents.</p>
//       </div>
//     </Page>
//   }
// />

// {/* Conflicts of Interest */}
// <Route
//   path="/policies/conflicts"
//   element={
//     <Page title="Conflicts of Interest">
//       <div className="text-left space-y-3">
//         <p>We seek to avoid conflicts; where unavoidable, we disclose, manage, and monitor them.</p>
//         <ul className="list-disc pl-6">
//           <li>Related-party transactions and outside business activities: pre-approval and disclosure.</li>
//           <li>Allocations across accounts: fair and equitable procedures.</li>
//           <li>Fees/compensation, soft dollars, and referral arrangements (if applicable): disclosure and controls.</li>
//           <li>Gifts and entertainment thresholds; political and charitable activity standards.</li>
//         </ul>
//       </div>
//     </Page>
//   }
// />

// {/* Personal Trading */}
// <Route
//   path="/policies/personal-trading"
//   element={
//     <Page title="Personal Trading &amp; Restricted List">
//       <div className="text-left space-y-3">
//         <p>Personnel trading is monitored to prevent conflicts and misuse of information.</p>
//         <ul className="list-disc pl-6">
//           <li>Pre-clearance for covered securities; blackout and restricted lists apply.</li>
//           <li>Duplicate confirmations/statements to compliance; periodic certifications.</li>
//           <li>No trading on material non-public information; information barriers enforced.</li>
//         </ul>
//       </div>
//     </Page>
//   }
// />

// {/* Best Execution & Allocation */}
// <Route
//   path="/policies/best-execution"
//   element={
//     <Page title="Best Execution &amp; Trade Allocation">
//       <div className="text-left space-y-3">
//         <p>We seek best execution and fair allocation across client accounts.</p>
//         <ul className="list-disc pl-6">
//           <li>Execution quality factors: price, liquidity, speed, certainty, and overall cost.</li>
//           <li>Broker/counterparty selection: periodic review of pricing and service quality.</li>
//           <li>Aggregated orders: policies to ensure equitable average pricing and fills.</li>
//         </ul>
//       </div>
//     </Page>
//   }
// />

// {/* Valuation & Pricing */}
// <Route
//   path="/policies/valuation"
//   element={
//     <Page title="Valuation &amp; Pricing">
//       <div className="text-left space-y-3">
//         <p>Consistent, documented valuation methods are used to price portfolios and any funds we manage.</p>
//         <ul className="list-disc pl-6">
//           <li>Hierarchy: observable market inputs preferred; models used where necessary.</li>
//           <li>Independent price checks and challenge; issue escalation and remediation.</li>
//           <li>Periodic reviews and controls around stale pricing and liquidity stress.</li>
//         </ul>
//       </div>
//     </Page>
//   }
// />

// {/* Cybersecurity */}
// <Route
//   path="/policies/cybersecurity"
//   element={
//     <Page title="Cybersecurity">
//       <div className="text-left space-y-3">
//         <p>Information security controls protect client and firm data.</p>
//         <ul className="list-disc pl-6">
//           <li>Access control, MFA, encryption at rest/in transit where appropriate.</li>
//           <li>Vendor risk management; patching and vulnerability management.</li>
//           <li>Incident response plan: detect, contain, notify, and remediate.</li>
//           <li>Employee training and phishing awareness.</li>
//         </ul>
//       </div>
//     </Page>
//   }
// />

// {/* Business Continuity */}
// <Route
//   path="/policies/business-continuity"
//   element={
//     <Page title="Business Continuity &amp; Disaster Recovery">
//       <div className="text-left space-y-3">
//         <p>We maintain plans to operate through disruptions and restore critical functions promptly.</p>
//         <ul className="list-disc pl-6">
//           <li>Critical function mapping, RTO/RPO targets, and backup testing.</li>
//           <li>Alternate work arrangements and communications protocols.</li>
//           <li>Periodic tabletop exercises and plan reviews.</li>
//         </ul>
//       </div>
//     </Page>
//   }
// />

// {/* Whistleblower */}
// <Route
//   path="/policies/whistleblower"
//   element={
//     <Page title="Whistleblower">
//       <div className="text-left space-y-3">
//         <p>We encourage reporting of concerns in good faith; retaliation is prohibited.</p>
//         <ul className="list-disc pl-6">
//           <li>Confidential channels to compliance or the board (as applicable).</li>
//           <li>Prompt, impartial investigation and remediation where warranted.</li>
//           <li>Recordkeeping and escalation protocols.</li>
//         </ul>
//       </div>
//     </Page>
//   }
// />

// {/* Privacy */}
// <Route
//   path="/privacy"
//   element={
//     <Page title="Privacy (PIPEDA)">
//       <div className="text-left space-y-3">
//         <p>We collect and use personal information for identified purposes (e.g., onboarding/KYC, servicing, compliance) and safeguard it appropriately.</p>
//         <ul className="list-disc pl-6">
//           <li>Consent and purpose limitation; minimal collection.</li>
//           <li>Administrative, technical, and physical safeguards.</li>
//           <li>Access and correction rights; how to contact us for privacy requests.</li>
//           <li>Service-provider obligations and cross-border considerations (if any).</li>
//         </ul>
//       </div>
//     </Page>
//   }
// />

// {/* Accessibility */}
// <Route
//   path="/policies/accessibility"
//   element={
//     <Page title="Accessibility Policy (AODA)">
//       <div className="text-left space-y-4">
//         <p>
//           GLEN UNION CAPITAL INC. is committed to providing accessible services and ensuring
//           equal access to our investment management services for all clients and stakeholders,
//           including persons with disabilities. In accordance with the Accessibility for Ontarians
//           with Disabilities Act (AODA) and the Integrated Accessibility Standards Regulation (IASR),
//           we strive to remove barriers and create an inclusive environment that enables everyone
//           to access our services with dignity and independence.
//         </p>

//         <div>
//           <p className="font-semibold">Accessibility Commitment and Principles</p>
//           <p>
//             Our accessibility commitment is guided by the principles of dignity, independence,
//             integration, and equal opportunity. We recognize that accessibility benefits everyone
//             and is essential for providing excellent client service. We are committed to meeting
//             the diverse needs of all individuals, including those with visible and non-visible
//             disabilities, and will continue to improve accessibility across all aspects of our
//             business operations, from client interactions to workplace practices.
//           </p>
//         </div>

//         <div>
//           <p className="font-semibold">Customer Service Standards</p>
//           <ul className="list-disc pl-6 space-y-2">
//             <li><strong>Accessible Communication:</strong> We provide information and communications in accessible formats upon request, including large print, electronic formats, or through assistive technologies.</li>
//             <li><strong>Service Animal Policy:</strong> Service animals are welcome in all areas of our premises where clients are normally allowed, in accordance with applicable laws and regulations.</li>
//             <li><strong>Support Person Accommodation:</strong> Clients with disabilities may be accompanied by a support person when accessing our services, and we will ensure both individuals are treated with respect and dignity.</li>
//             <li><strong>Assistive Devices:</strong> We welcome and accommodate the use of personal assistive devices and will provide assistance in using any assistive technologies we provide.</li>
//             <li><strong>Service Disruptions:</strong> In the event of planned or unexpected disruptions to accessible services, we will provide notice and alternative arrangements whenever possible.</li>
//           </ul>
//         </div>

//         <div>
//           <p className="font-semibold">Information and Communication Accessibility</p>
//           <p>
//             We are committed to making our information and communications accessible to persons
//             with disabilities. Our website is designed to meet Web Content Accessibility Guidelines
//             (WCAG) 2.0 Level AA standards, with features such as alternative text for images,
//             keyboard navigation compatibility, and clear content structure. We provide documents
//             in accessible formats upon request and ensure that our communication methods accommodate
//             various accessibility needs. Our staff are trained to communicate effectively with
//             persons with different types of disabilities.
//           </p>
//         </div>

//         <div>
//           <p className="font-semibold">Physical Environment and Facilities</p>
//           <p>
//             Our office facilities are designed to be accessible and barrier-free. We maintain
//             accessible parking spaces, entrance ramps, doorways with appropriate widths, accessible
//             washrooms, and meeting spaces that accommodate mobility devices. Signage is clear and
//             visible, with appropriate contrast and font sizes. We regularly assess our physical
//             environment to identify and remove barriers, and we consider accessibility requirements
//             when planning renovations or relocating facilities.
//           </p>
//         </div>

//         <div>
//           <p className="font-semibold">Employment Accessibility</p>
//           <p>
//             We are committed to fair and accessible employment practices throughout the recruitment,
//             hiring, and employment process. Job postings include statements about our commitment
//             to accessibility and accommodation. During recruitment, we inform candidates about
//             available accommodations and provide accessible formats for application materials
//             upon request. We work with employees to identify and implement workplace accommodations
//             that enable them to perform their job duties effectively while maintaining confidentiality
//             regarding accommodation needs.
//           </p>
//         </div>

//         <div>
//           <p className="font-semibold">Training and Awareness</p>
//           <p>
//             All employees, volunteers, and third parties who interact with clients on our behalf
//             receive accessibility training. This training covers the requirements of the AODA
//             and IASR, how to interact respectfully with persons with disabilities, how to use
//             assistive devices and technologies, and what to do if a person with a disability
//             is having difficulty accessing our services. Training is provided to new employees
//             during orientation and updated regularly to reflect changes in policies and practices.
//           </p>
//         </div>

//         <div>
//           <p className="font-semibold">Procurement and Third-Party Services</p>
//           <p>
//             When procuring goods, services, or facilities, we incorporate accessibility criteria
//             and features into our selection process. We work with vendors and service providers
//             to ensure they understand and support our accessibility commitments. Contracts with
//             third parties include accessibility requirements where applicable, and we provide
//             guidance to help them meet these standards. This ensures that accessibility is
//             considered throughout our supply chain and service delivery network.
//           </p>
//         </div>

//         <div>
//           <p className="font-semibold">Feedback and Continuous Improvement</p>
//           <p>
//             We welcome feedback about the accessibility of our services and are committed to
//             continuous improvement. Feedback can be provided through multiple channels including
//             phone, email, in-person, or through our website. All feedback is reviewed promptly,
//             and we work to address accessibility concerns and implement improvements. We regularly
//             review and update our accessibility policies and practices to ensure they remain
//             effective and compliant with current standards.
//           </p>
//         </div>

//         <div>
//           <p className="font-semibold">Compliance and Reporting</p>
//           <p>
//             We maintain documentation of our accessibility efforts and file required compliance
//             reports with the Accessibility Directorate of Ontario. Our accessibility plan is
//             reviewed and updated regularly to reflect our progress and identify areas for
//             continued improvement. We monitor changes to accessibility legislation and standards
//             to ensure ongoing compliance and best practices in accessibility service delivery.
//           </p>
//         </div>

//         <p className="text-sm italic">
//           For questions about this policy, to request accessible formats, or to provide feedback
//           about accessibility, please contact our Accessibility Coordinator. We are committed
//           to responding to accessibility requests in a timely manner.
//         </p>
//       </div>
//     </Page>
//   }
// />

//           <Route
//             path="/subsidiaries"
//             element={
//               <Page title="Subsidiaries & Investments">
//                 <div className="text-left space-y-3">
//                   <p>
//                     <strong>GLEN UNION CAPITAL INC.</strong> owns and operates{' '}
//                     <a href="https://karvon.co" target="_blank" rel="noreferrer"><strong>Karvon Investments Ltd.</strong></a>,
//                     an Ontario Business Corporation (BN 899970363, Registry ID 861656).
//                   </p>
//                   <p>Through Karvon, we facilitate investments in:</p>
//                   <ul className="list-disc pl-6">
//                     <li>Lithium</li>
//                     <li>Data-centre infrastructure</li>
//                     <li>AI infrastructure</li>
//                   </ul>
//                   <p className="italic">
//                     For information purposes only; not an offer or solicitation of securities.
//                   </p>
//                 </div>
//               </Page>
//             }
//           />

//           <Route
//             path="/contact"
//             element={
//               <Page title="Contact">
//                 <p>
//                   General inquiries: <a href="mailto:info@glenunioncapital.com">info@glenunioncapital.com</a>
//                 </p>
//                 <p className="mt-2">
//                   Mailing address:<br />
//                   GLEN UNION CAPITAL INC.<br />
//                   5700 Yonge St, North York,<br />
//                   ON M2N 5M9, Canada
//                 </p>
//               </Page>
//             }
//           />

//           <Route path="*" element={<Home />} />
//         </Routes>
//       </main>
//       <Footer />
//     </div>
//   );
// }
